import { HTMLAttributes, ReactNode } from 'react'
import tw, { TwStyle } from 'twin.macro'

type TypographyTypes = 'p' | 'span'
type TypographyVariants = 'body' | 'subbody' | 'caption'
type TypographyWeights = 'regular' | 'bold' | 'medium'

type TypographyProps = {
  as?: TypographyTypes
  variant?: TypographyVariants
  weight?: TypographyWeights
  text?: boolean
  children: ReactNode
  twStyle?: TwStyle | Array<TwStyle | undefined>
} & HTMLAttributes<HTMLHeadingElement>

const textVariants = (variant: TypographyVariants, text?: boolean) => {
  return {
    body: { ...tw`text-base leading-5 `, ...(text && tw`leading-[26px]`) },
    subbody: { ...tw`text-sm leading-[18px] `, ...(text && tw`leading-6`) },
    caption: { ...tw`text-xs leading-[14px] `, ...(text && tw`leading-[18px]`) }
  }[variant]
}

const textWeights = (weight: TypographyWeights) =>
  ({
    regular: tw`font-normal`,
    medium: tw`font-medium`,
    bold: tw`font-bold`
  }[weight])

const defaultStyles = (
  as: TypographyTypes,
  variant: TypographyVariants,
  weight: TypographyWeights,
  text?: boolean,
  twStyle?: TwStyle | Array<TwStyle | undefined>
) => [textVariants(variant, text), textWeights(weight), twStyle]

const Typography = ({
  as = 'p',
  variant = 'body',
  weight = 'regular',
  text = false,
  children,
  twStyle,
  ...props
}: TypographyProps) => {
  const Tag = as
  return (
    <Tag {...props} css={defaultStyles(as, variant, weight, text, twStyle)}>
      {children}
    </Tag>
  )
}

export default Typography
